const defaultState = [];

export const visitedProducts = (state = defaultState, action) => {
  return state;
};
